<script setup lang="ts">
import {computed} from 'vue'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'
import MenuItems from './MenuItems.vue'

type Emit = {
  toggleMenu: []
}

interface Props {
  showMenuItems: boolean
}

defineEmits<Emit>()
defineProps<Props>()

const isNewUiEnabled = useNewUiEnabled()

const menuClasses = ['group text-left bg-inherit whitespace-nowrap']

const menuItemClasses = computed(() => [
  'text-base',
  isNewUiEnabled.value
    ? 'text-new-tertiary-500 hover:text-new-tertiary-100 group-hover:text-new-tertiary-100'
    : 'text-brandlight hover:text-white group-hover:text-white',
  'tracking-widest uppercase cursor-pointer antialiased',
])

const subMenuClasses = computed(() => [
  'absolute bg-inherit shadow-md flex flex-col',
  isNewUiEnabled.value ? 'px-new-xl py-new-lg gap-y-[10px] min-w-[150px] rounded-lg' : 'p-4 gap-y-1',
  isNewUiEnabled.value
    ? 'text-base text-new-tertiary-500 hover:text-new-tertiary-100 tracking-widest uppercase cursor-pointer antialiased'
    : 'text-base text-brandlight hover:text-white tracking-widest uppercase cursor-pointer antialiased',
  isNewUiEnabled.value
    ? [
        'origin-top transform-gpu transition-all duration-200 ease-out',
        'invisible pointer-events-none -translate-y-1 scale-95 opacity-0',
        'group-hover:visible group-hover:pointer-events-auto group-hover:translate-y-0 group-hover:scale-100 group-hover:opacity-100',
      ]
    : 'transform transition ease-in-out duration-75 -translate-y-1/4 group-hover:translate-y-0 scale-y-0 group-hover:scale-y-100 opacity-0 group-hover:opacity-100',
])

const subMenuItemClasses = computed(() => [
  isNewUiEnabled.value ? 'text-new-tertiary-500 hover:text-new-tertiary-100' : 'text-brandlight hover:text-white',
  'tracking-normal normal-case cursor-pointer antialiased',
])
</script>

<template>
  <ul v-if="showMenuItems" class="flex flex-row gap-x-6 items-center bg-inherit z-header">
    <MenuItems
      :is-burger-menu="false"
      :menu-classes="menuClasses"
      :menu-item-classes="menuItemClasses"
      :sub-menu-classes="subMenuClasses"
      :sub-menu-item-classes="subMenuItemClasses"
      @toggle-menu="$emit('toggleMenu')"
    ></MenuItems>
  </ul>
  <template v-else>
    <div class="flex flex-grow"></div>
  </template>
</template>
